import b from 'b_';
import cn from 'classnames';
import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import LocationMenu from '../LocationMenu/LocationMenu';
import { ResearchStoreProp } from '../../stores/props';
import BrowserStore from '../../browser/stores/BrowserStore';
import FuseButton from '../FuseControls/FuseButton';
import { isFuse5Enabled } from '../../fuseFeatureFlag';
import OldTopBarResearchLocation from './OldTopBarResearchLocation';
import './TopBarResearchLocation.css';

const tbResearchBlock = b.lock('NewTopBarResearchLocation');

class NewTopBarResearchLocation extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        browser: BrowserStore.PropType.isRequired,
        research: ResearchStoreProp,
        onRefresh: PropTypes.func,
        className: PropTypes.string,
        btnProps: PropTypes.shape(FuseButton.propTypes),
    };

    getCommon() {
        const { research, t } = this.props;

        return {
            onClick: research.locationMenu.toggle,
            title: t('browserTopBar.menuButtonTitle'),
        };
    }
    getContent() {
        return <Fragment>
            <div className={tbResearchBlock('ResearchButtonText')}>
                {this.getLocationName()}
            </div>
        </Fragment>;
    }
    getLocationName() {
        const { research } = this.props;
        const location = research.getLocationById(research.location);
        const name = location ? location.name : research.location;
        return name.startsWith('Default:') ? name.replace('Default:', '').trim() : name;
    }
    getModal() {
        return this.props.research.locationMenu.isOpen
            ? <LocationMenu afterChange={this.props.onRefresh} />
            : null;
    }
    renderAlternative() {
        const { browser, btnProps, className, research } = this.props;
        const isTopBarMinified = browser.isTopBarMinificationAllowed();

        const btnIsOpen = research.locationMenu.isOpen;
        const mergedBtnProps = {
            ...btnProps,
            className: cn(
                'NewTopBarResearchLocation__btn',
                b.lock('interactive')({ minified: isTopBarMinified }),
                btnProps && btnProps.className,
                { 'NewTopBarResearchLocation__btn--focused': btnIsOpen },
            ),
            wrapperClassName: cn('NewTopBarResearchLocation__btnWrapper', btnProps && btnProps.wrapperClassName),
            iconRightClassName: cn('NewTopBarResearchLocation__btnIconRight', btnProps && btnProps.iconRightClassName),
        };

        return <div
            style={{ position: 'relative', display: 'flex' }}
            className={cn('NewTopBarResearchLocation', className)}
        >
            <FuseButton
                type="quaternary"
                iconRight="fuse_down_arrow"
                focus={btnIsOpen}
                {...this.getCommon()}
                extraSmall={isTopBarMinified}
                {...mergedBtnProps}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: 155,
                    }}
                >{this.getContent()}</div>
            </FuseButton>
            {this.getModal()}
        </div>;
    }
    render() {
        return this.renderAlternative();
    }
}

const WrappedNewTopBarResearchLocation = translate()(
    inject('env', 'research', 'browser')(observer(NewTopBarResearchLocation))
);

const TopBarResearchLocation = (props) => {
    return isFuse5Enabled()
        ? <WrappedNewTopBarResearchLocation {...props} />
        : <OldTopBarResearchLocation {...props} />;
};

export default TopBarResearchLocation;
